var map = {
	"./Audio.svg": "875e",
	"./Cards.svg": "853f",
	"./Video.svg": "c328",
	"./Website.svg": "cce5",
	"./bookmark_I.svg": "7968",
	"./bookmark_II.svg": "2947",
	"./free-access-books.svg": "a781",
	"./full-text-papers.svg": "43f0",
	"./interactive.svg": "185f",
	"./learning-platforms.svg": "30c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5d7a";